import { FC } from 'react';
import { EDataSourceCategory } from '@/models/dataSource';
import { CodeOverview, CrmOverview, FileOverview } from './overview';
import { SourceConnectorOverview } from './overview/SourceConnectorOverviewTab';
import { OverviewTabProps } from './overview/types/types';

export const DataSourceOverview: FC<OverviewTabProps> = ({ dataSource, isActive }) => {
  switch (dataSource?.type.category) {
    case EDataSourceCategory.CODE:
      return <CodeOverview dataSource={dataSource} isActive={isActive} />;
    case EDataSourceCategory.FILE:
      return <FileOverview dataSource={dataSource} isActive={isActive} />;
    case EDataSourceCategory.CRM:
      return <CrmOverview dataSource={dataSource} isActive={isActive} />;
    case EDataSourceCategory.SOURCE_CONNECTOR:
      return <SourceConnectorOverview dataSource={dataSource} isActive={isActive} />;
    default:
      return <div></div>;
  }
};
